import React from 'react';

import { IQuickAccess } from '../../../../interfaces/button';
import StyledCircularProgress from '../../../StyledCircularProgress/StyledCircularProgress';

import './QuickAccess.scss';

const QuickAccess = ({ icon, description, action, loading = false }: IQuickAccess) => {
  return (
    <button className="quick-access-v3" onClick={action} disabled={loading} data-experience="new">
      {loading ? (
        <span className="w-8 h-8">
          <StyledCircularProgress />
        </span>
      ) : (
        <icon.component className="w-8 h-8" />
      )}
      <div> {description} </div>
    </button>
  );
};

export default QuickAccess;
